import React from "react";
import Input from "../../../../../Components/Input";
import WhatsAppConfigurationController from "../../../../Controllers/AdminScreens/Configuration/ConfigurationCenter/WhatsAppConfigurationController";
import Loader from "../../../../../Components/Loader";
import MobileInput from "../../../../../Components/MobileInput";
import LoadingSkeleton from "../../../../../Components/LoadingSkeleton";

const WhatsAppConfiguration = ({ data, loading, error, onRefresh }) => {
  const {
    accessToken,
    setAccessToken,
    webhookUrl,
    setWebhookUrl,
    whatsappId,
    setWhatsappId,
    whatsappMobileNo,
    setWhatsappMobileNo,
    saveLoading,
    saveError,
    success,
    saveWhatsAppConfig,
    urlError,
    setUrlError,
    accessTokenError,
    setAccessTokenError,
    handleCancel,
    countryCode,
    setCountryCode,
    mobileNoError,
    setMobileNoError,
  } = WhatsAppConfigurationController(data, loading, error, onRefresh)

  return (
    <div className='basic-info-container' >
      <h3 className="tasksScreen-tasks-title" style={{ paddingBottom: 20, fontFamily: 'Roboto Slab' }}>WhatsApp</h3>
      {loading ? (
        <div style={{ display: 'flex', gap: '80px' }}>
          <div>
            <label style={styles.label}>{'Access Token'}</label>
            <div style={{ marginTop: 10 }}>
              <LoadingSkeleton width="150%" height="15px" />
            </div>
          </div>
          <div>
            <label style={styles.label}>{'Webhook URL'}</label>
            <div style={{ marginTop: 10 }}>
              <LoadingSkeleton width="150%" height="15px" />
            </div>
          </div>
          <div>
            <label style={styles.label}>{'WhatsApp ID'}</label>
            <div style={{ marginTop: 10 }}>
              <LoadingSkeleton width="150%" height="15px" />
            </div>
          </div>
          <div>
            <label style={styles.label}>{'WhatsApp Business No.'}</label>
            <div style={{ marginTop: 10 }}>
              <LoadingSkeleton width="150%" height="15px" />
            </div>
          </div>
        </div>
      ) : (
        <div className="tasksScreen-filters">
          <Input
            label="Access Token"
            placeholder="Enter Access Token"
            value={accessToken}
            onChange={(e) => { setAccessToken(e.target.value); setAccessTokenError('') }}
            errorMessage={accessTokenError}
          />
          <Input
            label="Webhook URL"
            placeholder="Enter Webhook URL"
            value={webhookUrl}
            onChange={(e) => { setWebhookUrl(e.target.value); setUrlError('') }}
            errorMessage={urlError}
          />
          <Input
            label="WhatsApp ID"
            placeholder="Enter App ID"
            value={whatsappId}
            onChange={(e) => setWhatsappId(e.target.value)}
          />
          <Input
            label="WhatsApp Business No."
            placeholder="Enter Mobile Number"
            value={whatsappMobileNo}
            onChange={(e) => { setWhatsappMobileNo(e.target.value); setMobileNoError('') }}
            inputType='number'
            maxLength={10}
            errorMessage={mobileNoError}
          />
          {/* <MobileInput
          label="Mobile No."
          countryCode={countryCode}
          mobileNumber={whatsappMobileNo}
          onCountryChange={setCountryCode}
          onMobileChange={setWhatsappMobileNo}
          placeholder="Enter Mobile Number"
          countries={[
            { code: "IN", dialCode: "+91" },
            { code: "US", dialCode: "+1" },
            { code: "UK", dialCode: "+44" },
          ]}
        /> */}
        </div>
      )}
      <div className="button-container" style={{ marginTop: '25px' }} >
        {saveError && <div className="list-error-msg" style={{ padding: 0 }}> {saveError}</div>}
        {success && <div className="list-success-msg" style={{ padding: 0 }}> {success}</div>}
      </div>
      <div className="button-container" style={{ marginBottom: '30px', }} >
        <button className="add-client-button" style={{ marginRight: '8px', paddingLeft: '30px', paddingRight: '30px', opacity: saveLoading || loading ? 0.5 : 1 }} onClick={saveWhatsAppConfig} disabled={saveLoading || loading}>
          {(saveLoading || loading) &&
            <span style={{ paddingRight: 5 }} ><Loader loading={saveLoading || loading} color={'var(--background-color)'} size="small" /> </span>
          }{data ? "Update" : "Add"}</button>
        <button className="cancel-button" onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  )

}

export default WhatsAppConfiguration;

const styles = {
  label: {
    fontSize: '12px',
    color: '#343C44',
    fontWeight: 400,
    fontFamily: 'Roboto'
  },
};
